import { default as FieldInfoModal } from "./FieldInfoModalContainer";
export default FieldInfoModal;
